import NsiApi from '../../api/nsi'

export default {
  namespaced: true,
  state: {
    dictionary: null,
    listPage: null,
    item: null
  },
  getters: {
  },
  mutations: {
    setDictionary(state, dict) {
      state.dictionary = dict;
    },
    setListPage(state, page) {
      state.listPage = page;
    },
    setItem(state, item) {
      state.item = item;
    }
  },
  actions: {
    getDictionary(context, name) {
      return NsiApi.getDictionary(name).then(function (response) {
        context.commit('setDictionary', response.data)
      });
    },
    searchNsi(context, request) {
      return NsiApi.getItems(request).then(function (response) {
        context.commit('setListPage', response.data)
      });
    },
    getItem(context, request) {
      if (request.id > 0) {
        return NsiApi.getItem(request).then(function (response) {
          context.commit('setItem', response.data)
        });
      }
      return context.commit('setItem', {id: 0, name: ''});
    }
  },
  modules: {
  }
}